import {
  HomeMyServicesApi,
  HomeMyServicesInstallationApi,
  HomeMyServicesSocietyApi,
} from '@core/api/model/home/home-my-services-api.model';
import { HomeMyServices, HomeMyServicesInstallation, HomeMyServicesSociety } from '@core/domain/model/home/home-my-services.model';

export class HomeMyServicesMapper {
  public static modelFromApi(api: HomeMyServicesApi): HomeMyServices {
    return {
      ...api,
      sociedades: api.sociedades.map((value) => HomeMyServicesMapper.societyModelFromApi(value)),
    };
  }

  private static societyModelFromApi(api: HomeMyServicesSocietyApi): HomeMyServicesSociety {
    return {
      ...api,
      instalaciones: api.instalaciones.map((value) => HomeMyServicesMapper.installationModelFromApi(value)),
    };
  }

  private static installationModelFromApi(api: HomeMyServicesInstallationApi): HomeMyServicesInstallation {
    return {
      ...api,
    };
  }
}
